import styled from 'styled-components'

import { Modal } from '@sketch/components'
import { breakpoint } from '@sketch/global-styles'

export const StyledModal = styled(Modal)`
  max-width: 334px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${breakpoint('base', 'sm')`
    margin: auto 0;
  border-radius: 16px;
    
  `}
`

export const Header = styled(Modal.Header)`
  &&& {
    padding-top: 26px; /* stylelint-disable-line scales/space */
  }
`

export const Body = styled(Modal.Body)`
  text-align: center;
`

export const Image = styled.img`
  margin-top: 32px;

  ${breakpoint('base', 'sm')`
      margin-top: 16px;

  `}
`
